<template>
  <div>
    <HeroSmall />
    <b-container class="mt-5 mb-5">
      <h1 class="display-1">Corporate Blog</h1>
    </b-container>
  </div>
</template>

<script>
import HeroSmall from '@/components/ui/HeroSmall.vue'
export default {
  name: 'Blog',
  components: {
    HeroSmall,
  }
}
</script>

<style scoped>

</style>